import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './pages/auth/auth.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeComponent } from './pages/home/home.component';
import { ChangeTermsPurchaseComponent } from './pages/change-terms-purchase/change-terms-purchase.component';
import { BlockComponent } from './pages/block/block.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: 'registry',
    loadChildren: 'app/pages/registry/registry.module#RegistryModule'
  },
  {
    path: 'document',
    loadChildren: 'app/document/document.module#DocumentModule'
  },
  {
    path: 'change-terms-purchase/:number', // path: 'change-terms-purchase/',
    component: ChangeTermsPurchaseComponent,
  },
  {
    path: 'block/:number', // path: 'change-terms-purchase/',
    component: BlockComponent,
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts